import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';


class UpdateCatalog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codes: "",
            isrcs: "",
            selectedOption: null,
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
    if (this.props.catalogCodes.length > 0 && !this.props.isSavingCatalog) {
        this.props.saveCatalog(this.props.catalogCodes[0], this.props.requestedCatalog);
    }
   
   
    }

   

ensureDataFetched() {
   
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }


    onUPCChange(e) {
        this.setState({ codes: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setCatalogUpdate(e, selection) {
        var array = e.split(" ");       
        this.props.setCatalogCodes(array,selection);
    }


render() {
    const access = localStorage.getItem("accessToken");    
    let url = this.props ? this.props.audioURL : '';
    const options = [
        { value: 'Adam Rose', label: 'Adam Rose' },
        { value: 'Black Lace', label: 'Black Lace' },
        { value: 'Burning Girl', label: 'Burning Girl' },
        { value: 'Calming River', label: 'Calming River' },
        { value: 'Clive Harvey', label: 'Clive Harvey' },
        { value: 'Countdown Type A', label: 'Countdown Type A' },
        { value: 'Countdown Type B', label: 'Countdown Type B' },
        { value: 'Dutch Artists', label: 'Dutch Artists' },
        { value: 'Elap', label: 'Elap' },
        { value: 'EMG', label: 'EMG' },
        { value: 'EMG Classical', label: 'EMG Classical' },
        { value: 'Glee', label: 'Glee' },
        { value: 'Glucose', label: 'Glucose' },
        { value: 'INA', label: 'INA' },
        { value: 'Jack Robinson', label: 'Jack Robinson' },
        { value: 'Jazz Archives Original', label: 'Jazz Archives Original' },
        { value: 'Jazz Archives PD', label: 'Jazz Archives PD' },
        { value: 'Kandis', label: 'Kandis' },
        { value: 'Katrina', label: 'Katrina' },
        { value: 'Kogekunst', label: 'Kogekunst' },
        { value: 'Lennart Krarup', label: 'Lennart Krarup' },
        { value: 'Lumi-PD', label: 'Lumi-PD' },
        { value: 'Metacom', label: 'Metacom' },
        { value: 'Middle of the road', label: 'Middle of the road' },
        { value: 'MMI Covers', label: 'MMI Covers' },
        { value: 'MMI Originals', label: 'MMI Originals' },
        { value: 'MMI Re-recordings', label: 'MMI Re-recordings' },
        { value: 'MMI Unknown', label: 'MMI Unknown' },
        { value: 'MMI WW', label: 'MMI WW' },
        { value: 'MMI PD', label: 'MMI PD' },
        { value: 'Music For Dreams', label: 'Music For Dreams' },
        { value: 'Music of Life', label: 'Music of Life' },
        { value: 'Nigel Fletcher', label: 'Nigel Fletcher' },
        { value: 'Ocean Music', label: 'Ocean Music' },
        { value: 'PD-PRO', label: 'PD-PRO' },
        { value: 'Prestige', label: 'Prestige' },
        { value: 'Roba', label: 'Roba' },
        { value: 'Saks Film', label: 'Saks Film' },
        { value: 'San Juan', label: 'San Juan' },
        { value: 'San Juan Re-Recordings', label: 'San Juan Re-Recordings' },
        { value: 'Santilli - Lumi', label: 'Santilli - Lumi' },
        { value: 'Santilli - Orbital', label: 'Santilli - Orbital' },
        { value: 'Sherman', label: 'Sherman' },
        { value: 'Sherman-WW', label: 'Sherman-WW' },
        { value: 'Siro', label: 'Siro' },
        { value: 'Smokie', label: 'Smokie' },
        { value: 'Spats Music', label: 'Spats Music' },
        { value: 'Verner', label: 'Verner' },
        { value: 'Weal Entertainment', label: 'Weal Entertainment' },
        { value: 'Chris France', label: 'Chris France' },
        { value: 'Tuff Audio', label: 'Tuff Audio' },
        { value: 'Nicki French', label: 'Nicki French' },
        { value: 'Lars Lilholt', label: 'Lars Lilholt' },
        { value: 'Key Note Music', label: 'Key Note Music' },
        { value: 'Sherman PD', label: 'Sherman PD' },
        { value: 'Cheetah Play', label: 'Cheetah Play' },
        { value: 'Funky Juice', label: 'Funky Juice' },
        { value: 'Funky Juice - Sync Only', label: 'Funky Juice - Sync Only' },
        { value: 'Matterhorn Records', label: 'Matterhorn Records' },
        { value: 'Beth Porter', label: 'Beth Porter' },
        { value: 'The Bookshop Band', label: 'The Bookshop Band' },
        { value: 'Block Legacy', label: 'Block Legacy' },
        { value: 'Forrest James', label: 'Forrest James' },
        { value: 'Atlantic Screen Music', label: 'Atlantic Screen Music' },
        { value: 'Village Recordings', label: 'Village Recordings' },
        { value: 'David Victor', label: 'David Victor' },
        { value: 'Jacob Speake', label: 'Jacob Speake' },
        { value: 'Bethia Beadman', label: 'Bethia Beadman' },
        { value: 'The Girls', label: 'The Girls' },
        { value: 'Kitrocket', label: 'Kitrocket' },
        { value: 'Jennifer Crook', label: 'Jennifer Crook' },
        { value: 'Brand WW ex USA', label: 'Brand WW ex USA' },
        { value: 'Brand WW', label: 'Brand WW' },
        { value: 'Brand PD', label: 'Brand PD' },
        { value: 'VeldHans', label: 'VeldHans' },
        { value: 'Countdown Kids', label: 'Countdown Kids' },
        { value: 'Countdown Vuducru', label: 'Countdown Vuducru' },
        { value: 'Steve Ross', label: 'Steve Ross' },
        { value: 'JAM Music (Legacy)', label: 'JAM Music (Legacy)' },
        { value: 'JAM Music (New)', label: 'JAM Music (New)' },
        { value: 'Two Camels WW', label: 'Two Camels WW' },
        { value: 'Two Camels PD', label: 'Two Camels PD' },
        { value: 'Chris Norman (Legacy)', label: 'Chris Norman (Legacy)' },
        { value: 'Chris Norman (New)', label: 'Chris Norman (New)' },
        { value: 'Big Debbie', label: 'Big Debbie' },
        { value: 'Keld_and_Hilda', label: 'Keld & Hilda' },
        { value: 'Apollo Music', label: 'Apollo Music' },
        { value: 'Vikingarna', label: 'Vikingarna' },
        { value: 'Heick Music', label: 'Heick Music' },
        { value: 'Showbizz Danmark', label: 'Showbizz Danmark' },
        { value: 'KB Music', label: 'KB Music' },
        { value: 'Renee Sondergaard', label: 'Renée Søndergaard'},
        { value: 'Thomas Martini Jorgensen', label: 'Thomas Martini Jørgensen' },
        { value: 'Inge Marie', label: 'Inge Marie'},

        
    ];
    const { selectedOption } = this.state;

    
    

    return (
        <div>              
                <h1>Catalogs Update</h1>

            <p>{this.props.catalogCodes.length} items left to update </p>
            <p>{this.props.catalogCodes.length > 0 ? "Updating " + this.props.requestedCatalogCode + " to " + selectedOption.label : ""}</p>
            <p>{this.props.catalogCodes.length > 0 ? "(please don't reload or close the tab)" : ""}</p>
          
                <div className="row">
                <div className="col-sm-6">
                    <input type="text" disabled={this.props.isSavingCatalog || this.props.catalogCodes.length > 0} className="form-control" id="shortlistISRC" placeholder={"UPCS/ISRCS to Update"} onChange={(e) => this.onUPCChange(e)} value={this.state.codes} ></input>
                </div>
                <div className="col-sm-3">
                    <Select
                        isLoading={options.length === 0}
                        name="form-field-name"
                        value={selectedOption}
                        options={options}
                        multi={false}
                        onChange={(data) => this.selectListType(data)}
                        disabled={this.props.isSavingCatalog || this.props.catalogCodes.length > 0 }
                    /></div>
                <div className="col-sm-3">
                    <button disabled={this.state.codes === '' || this.props.isSavingCatalog || selectedOption === null || this.props.catalogCodes.length > 0} onClick={(e) => this.setCatalogUpdate(this.state.codes, selectedOption.value)}>Update</button></div>
            </div>

            <br />

          
            <br/>
                <div className="row">
                <div className="col-sm-12">
                    {this.props.catalogResults !== null && this.props.catalogResults.length > 0 ? <CSVLink separator=";" data={this.props.catalogResults} filename={selectedOption.value + "-List-Data.csv"} >Download CSV</CSVLink> : ""}
                    {this.props.catalogResults.length > 0 ? renderReactTable(this.props.catalogResults, this.props, this) : ""}
                    </div>
                </div>

            </div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);

    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(UpdateCatalog);



// WEBPACK FOOTER //
// ./src/components/UpdateCatalog.js